import { service } from '@/decorators/service';

export interface IStatusMsgContextEntry {
  context: unknown;
  expiresAt: number;
  suppressSuccessToast?: boolean;
}

@service(StatusMsgContext)
export class StatusMsgContext {
  private readonly entries: Map<string, IStatusMsgContextEntry> = new Map();

  set(correlationKey: string, context: unknown, ttlMs = 60000, suppressSuccessToast = false) {
    if (!correlationKey) {
      return;
    }

    this.prune();
    this.entries.set(correlationKey, {
      context,
      expiresAt: Date.now() + ttlMs,
      suppressSuccessToast,
    });
  }

  getEntry(correlationKey: string): IStatusMsgContextEntry | undefined {
    if (!correlationKey) {
      return undefined;
    }

    this.prune();
    return this.entries.get(correlationKey);
  }

  get(correlationKey: string): unknown {
    if (!correlationKey) {
      return undefined;
    }

    this.prune();
    return this.entries.get(correlationKey)?.context;
  }

  delete(correlationKey: string) {
    this.entries.delete(correlationKey);
  }

  prune(now = Date.now()) {
    for (const [key, entry] of this.entries.entries()) {
      if (entry.expiresAt <= now) {
        this.entries.delete(key);
      }
    }
  }
}
